import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../Containers/Config/index.js';
import { SERVICE_WISE_SLA_PAIN_MINUTES, SERVICE_WISE_SLA_PAIN_MINUTES_ERROR, SERVICE_WISE_SLA_PAIN_MINUTES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* serviceWiseSlaPainMinutes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SERVICE_WISE_SLA_PAIN_MINUTES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SERVICE_WISE_SLA_PAIN_MINUTES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SERVICE_WISE_SLA_PAIN_MINUTES_ERROR, payload: error });
  }
}

export function* watchServiceWiseSlaPainMinutes() {
  yield takeEvery(SERVICE_WISE_SLA_PAIN_MINUTES, serviceWiseSlaPainMinutes);
}

function* serviceWiseSlaPainMinutesSaga() {
  yield all([fork(watchServiceWiseSlaPainMinutes)]);
}

export default serviceWiseSlaPainMinutesSaga;
